module.exports = __webpack_public_path__ + "img/jk1_mb.e48cd1be.jpg";